import { YandexMetrikaAbTestFlagKeys } from '@analytics/const';
import { Injectable } from '@angular/core';
import { YandexMetrikaService } from './yandex-metrika.service';

@Injectable({ providedIn: 'root' })
export class AbTestAnalyticsService {
  private mapShownVariants = new Map<YandexMetrikaAbTestFlagKeys, true>();

  constructor(private yandexMetrikaService: YandexMetrikaService) {}

  sendEventVariantWasShown(experimentFlag: YandexMetrikaAbTestFlagKeys, experimentVariant?: string): void {
    if (experimentVariant && !this.mapShownVariants.has(experimentFlag)) {
      this.mapShownVariants.set(experimentFlag, true);
      this.yandexMetrikaService.setParams({ АБтест: { [experimentFlag]: experimentVariant } });
    }
  }
}
